export default "__VITE_ASSET__dc27aef3__"